import React from 'react';

import Modal from '../../../components/modals/Modal';

import './ChangeShelfModal.scss';
import { BundleJson } from '../../../types/bundleTypes';
import Fetch from '../../../utils/fetch';
import { settings } from '../../../settings';

import Alert from '../../../components/alerts/Alert';

interface State {
  showSuccessModal: boolean;
  shelfId?: string;
  errorMessage?: string;
  success: boolean;
}

interface Props {
  bundle: BundleJson;
  onCloseModal: () => void;
  onSelectModal: (shelfId: string) => void;
}

export default class ChangeShelfModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showSuccessModal: true,
      shelfId: this.props.bundle.shelfId,
      success: false,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
  }
  onKeyDown(event) {
    if (event.keyCode === 27) {
      this.props.onCloseModal();
    } else if (event.keyCode === 13) {
      this.changeShelf();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  changeShelf = async () => {
    const shelfId = this.state.shelfId;
    if (!shelfId) {
      return;
    }
    if (shelfId === this.props.bundle.shelfId) {
      this.props.onSelectModal(shelfId);
      return;
    }

    const success = await this.setShelfIdInBundle();
    if (success) {
      this.props.bundle.shelfId = this.state.shelfId;

      this.setState({ success: true });

      setTimeout(() => {
        this.props.onSelectModal(shelfId);
      }, 1500);
    }
  };

  updateShelfValue = event => {
    const value = event.target.value;
    if (value.length > 3) {
      return;
    }
    if (value.length === 0) {
      this.setState({ shelfId: '' });
      return;
    }
    if (!value.match(/^[a-z0-9]+$/i)) {
      return;
    }
    this.setState({ shelfId: value.toUpperCase() });
  };

  setShelfIdInBundle = async (): Promise<boolean> => {
    const bundle = this.props.bundle;
    const bundleId = bundle.id;
    const newShelfId = this.state.shelfId;

    this.setState({
      errorMessage: '',
    });

    try {
      const response = await Fetch.put({
        url: `${settings.newApiUrl}/bundle/${bundleId}/shelf`,

        body: {
          shelfId: newShelfId,
        },
      });
      if (response.status === 422) {
        const msg = await response.json();
        this.setState({
          errorMessage: msg[0].message,
        });
        return false;
      } else if (!response.ok) {
        this.setState({
          errorMessage: 'The shelf ID could not be changed',
        });
        return false;
      }
    } catch (e) {
      console.warn(
        `Error setting shelf ${newShelfId} for bundle ${bundleId}`,
        e
      );
      this.setState({
        errorMessage: 'The shelf ID could not be changed',
      });
      return false;
    }

    return true;
  };

  render() {
    return (
      <Modal
        title={`Bundle ${this.props.bundle.id}`}
        onClose={() => this.props.onCloseModal()}
        buttons={[
          {
            title: 'Confirm',
            onClick: () => {
              this.changeShelf();
            },
            loading: false,
            disabled: this.state.success || !this.state.shelfId,
          },
        ]}
      >
        <div className="change-shelf-modal-content">
          <span className="change-shelf-modal-desc">Enter new Shelf ID: </span>
          <div style={{ width: 10 }} />
          <input
            style={{ width: 100 }}
            maxLength={3}
            value={this.state.shelfId}
            onChange={this.updateShelfValue}
            autoFocus={true}
          />
          <div style={{ height: 10 }} />
        </div>
        {this.state.errorMessage && (
          <Alert type="warning" style={{ marginTop: 10 }}>
            {this.state.errorMessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert type="success" style={{ marginTop: 10 }}>
            {`Bundle ${this.props.bundle.id} has been assigned to shelf '${this.state.shelfId}'`}
          </Alert>
        )}
      </Modal>
    );
  }
}
